module.exports = __webpack_public_path__ + "img/kevin-liu-482368-unsplash.eb51312f.jpg";